export default "__VITE_ASSET__C5S5VJd___"